/**
 * Upload file categories.
 *
 * Shared by api (upload DTOs) and web (upload API client). Both sides
 * historically used an `enum`, so this stays an enum (member access everywhere);
 * value import gives the runtime object for `@IsEnum` / `@ApiProperty({ enum })`.
 *
 * C18: every category is either PUBLIC (anonymous bucket reads allowed) or
 * PRIVATE (presigned GET only). The authoritative split lives in
 * constants/pii.ts + docs/design/security-privacy.md §3.2 — a test fails if a
 * new member is not registered there.
 */
export var FileCategory;
(function (FileCategory) {
    FileCategory["PROFILE_PHOTO"] = "profile-photo";
    FileCategory["CERTIFICATE"] = "certificate";
    FileCategory["JUDGE_CERTIFICATE"] = "judge-certificate";
    FileCategory["DOCUMENT"] = "document";
    FileCategory["SPONSOR_LOGO"] = "sponsor-logo";
    FileCategory["CAROUSEL_IMAGE"] = "carousel-image";
    FileCategory["SYSTEM_LOGO"] = "system-logo";
    FileCategory["RESOURCE"] = "resource";
    FileCategory["INSURANCE"] = "insurance";
    FileCategory["SUBMISSION_FILE"] = "submission-file";
    FileCategory["CONFIRMATION_PHOTO"] = "confirmation-photo";
    FileCategory["CERTIFICATE_FONT"] = "certificate-font";
})(FileCategory || (FileCategory = {}));
//# sourceMappingURL=upload.js.map